export default __webpack_public_path__ + "static/media/homepage_slider4.6e64751f.webp";